import React from "react";
import { Stack, Typography } from "@mui/material";
import {LogoIcon} from "../Icon";

const Logo = (props) => {
  const { text = "Guardian Angel" } = props;
  return (
    <Stack
      direction={"row"}
      justifyContent={"center"}
      alignItems={"center"}
      gap={1}
      sx={{ height: 40 }}
    >
      {/* <img src={`${logo}`}  alt="logo" width={`100%`} /> */}
      <LogoIcon sx={{ fontSize: 34 }} />
      <Typography variant="h3" sx={{ color: "#101828" }}>
        {text}
      </Typography>
    </Stack>
  );
};

export default Logo;
